module.exports = __webpack_public_path__ + "static/media/sf_restaurant_13.b77e1100.jpg";